<template>
  <div>
    <v-card>
      <v-card-title><h1>Tree</h1></v-card-title>
      <div class="box">
        <div class="d-flex">
          <v-btn small right class="mb-2" @click="expandAll(true)"><v-icon small>mdi-arrow-expand-vertical</v-icon></v-btn>
          <v-btn small right class="mb-2" @click="expandAll(false)"><v-icon small>mdi-arrow-collapse-vertical</v-icon></v-btn>
        </div>
        <tree-data-table :headers="headers" :items="items" :open-all="openAll" @click:expand="expand" @click:row="highlight" @contextmenu:row="showContextMenu" height="500" dense hide-default-footer disable-pagination fixed-header single-select>
          <template #item.step="{ value }"> {{ value | comma }} </template>
        </tree-data-table>
      </div>
    </v-card>

    <v-menu v-model="showMenu" :position-x="x" :position-y="y" z-index="10" absolute offset-y>
      <v-list dense>
        <v-list-item link>
          <v-list-item-title>Menu#1</v-list-item-title>
        </v-list-item>
        <v-list-item link>
          <v-list-item-title>Menu#2</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'tree',
  data() {
    return {
      // TreeDataTable 컴포넌트는 headers에 expandable 이 true인 값을 기준으로
      // expand/collapse 기능을 추가하므로 원하는 컬럼에 expandable: true를 설정한다.
      headers: [
        { text: '', sortable: false, width: '2%' },
        { text: '시스템 메뉴', value: 'name', sortable: false, width: '20%', expandable: true },
        { text: '총 스텝수', value: 'step', sortable: false, width: '10%' },
        { text: 'Ø R.T.', value: 'a', sortable: false },
        { text: 'Ø Wait', value: 'b', sortable: false },
        { text: 'Ø Roll in', value: 'c', sortable: false },
        { text: 'Ø Load+Gen', value: 'd', sortable: false },
        { text: 'Ø Proc', value: 'e', sortable: false },
      ],
      items: [],
      openAll: false,

      // context menu
      showMenu: false,
      x: 0,
      y: 0,
    };
  },
  created() {
    // TreeDataTable을 사용하기 위해서는 아래와 같이 계층적인(Hierarchical) 데이터가 요구되고
    // 또 그 데이터는 계층들 중 어떤 데이터가 Leaf 노드인지 표현되어야 한다.
    // 즉 TreeDataTable 이 필수적인 속성은 다음과 같다.
    // - children: 자식을 포함
    // - leaf: 마지막 노드 여부
    // eslint-disable-next-line prettier/prettier
    this.items = [
      {
        id: '1',
        name: 'Office',
        children: [
          { id: '1-1', name: 'Office-1' },
          {
            id: '1-2',
            name: 'Office-2',
            children: [
              { id: '1-2-1', name: 'Office-2-1', leaf: true, step: 123 },
              { id: '1-2-2', name: 'Office-2-2', leaf: true, step: 3941 },
              {
                id: '1-2-3',
                name: 'Office-2-3',
                children: [
                  { id: '1-2-3-1', name: 'Office-2-3-1', leaf: true, step: 8 },
                  { id: '1-2-3-2', name: 'Office-2-3-2', leaf: true, step: 85 },
                  { id: '1-2-3-3', name: 'Office-2-3-3', leaf: true, step: 392 },
                ],
              },
            ],
          },
          { id: '1-3', name: 'Office-3' },
        ],
      },
      { id: '2', name: 'Cross-Application Components' },
    ];
  },
  methods: {
    expandAll(value) {
      this.openAll = value;
    },
    // { expanded, loading, add, remove } arguments는 사용하고 싶은 것만 선택적으로 가능
    expand(node, { expanded, loading, add, remove }) {
      // _opened는 컴포넌트를 사용하는 곳에서 트리를 오픈할 때 이미 한 번 오픈한 Node인지 식별하기 위한 설정 값
      // 보통 비동기 통신에서 한 번만 데이터를 가져오기 위해 사용됨
      if (!node._opened) {
        loading(true);
        const id = this.genId();
        setTimeout(() => {
          if (node.id === '1-1') {
            remove(node);
          } else {
            const newNode = { id, name: `chotire-${id}`, step: id };
            add(newNode);
          }
          loading(false);
        }, 500);
      }
      console.log(node, expanded, loading, add);
    },
    genId() {
      return Math.floor(Math.random() * (100000 - 1) + 1);
    },
    // { headers, expanded, selected, item, select } arguments는 사용하고 싶은 것만 선택적으로 가능
    highlight(node, { headers, expanded, selected, item, select }) {
      select(!selected);
      console.log(headers, expanded, selected, item, select);
    },
    // { headers, expanded, selected, item, select } arguments는 사용하고 싶은 것만 선택적으로 가능
    showContextMenu(event, { headers, expanded, selected, item, select }) {
      event.preventDefault();
      this.x = event.clientX;
      this.y = event.clientY;
      this.showMenu = true;
      console.log(headers, expanded, selected, item, select);
    },
  },
};
</script>

<style lang="scss" scoped></style>
